// tslint:disable
export interface DoorbellConfiguration {
  enabled: boolean;
  appKey: string | null;
}

export function bootstrapDoorbell({ enabled, appKey }: DoorbellConfiguration) {
  if (!enabled) {
    return;
  }

  (function (w, d, t) {
    w.doorbellOptions = { appKey: appKey };
    let hasLoaded = false;
    function l() {
      if (hasLoaded) {
        return;
      }
      hasLoaded = true;
      w.doorbellOptions.windowLoaded = true;
      const g = d.createElement(t);
      g.id = 'doorbellScript';
      g.type = 'text/javascript';
      g.async = true;
      g.src = 'https://embed.doorbell.io/button/6364?t=' + new Date().getTime();
      (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(g);
    }
    if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else if (w.addEventListener) {
      w.addEventListener('load', l, false);
    } else {
      l();
    }
    if (d.readyState === 'complete') {
      l();
    }
  })(window as any, document as any, 'script');
}
